export default "__VITE_ASSET__BYP__$2U__"